var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReusableLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.465,
    cy: 70.3727,
    r: 69.7345,
    fill: "#E6F0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5528 36.4897H42.7949V96.124C42.7949 103.869 49.0611 110.205 56.8762 110.205H84.0531C91.7978 110.205 98.1344 103.939 98.1344 96.124V36.4897H86.0949V54.8658C86.0949 58.7382 82.9266 61.9065 79.0543 61.9065H61.5935C57.7211 61.9065 54.5528 58.7382 54.5528 54.8658V45.8538V36.4897Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3964 87.9565L56.3128 94.9972C55.82 95.8421 56.1016 96.8982 56.9465 97.3206L58.1434 98.0247C58.425 98.2359 58.7771 98.3063 59.1995 98.3063H67.1554V94.6452H60.8188",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3972 87.9566L58.4258 86.7597L64.5511 84.4363L65.6072 90.9841L63.5655 89.7872",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.129 98.236C59.0586 97.8135 59.0586 97.3911 59.3402 96.9687L63.4942 89.7168",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6035 97.8838H83.7707C84.686 97.8838 85.4604 97.1093 85.4604 96.1941V94.8563C85.4604 94.5043 85.39 94.1523 85.1788 93.8002L81.236 86.9004L78.0677 88.731L81.236 94.2227",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6044 97.8838V100.207L70.5352 95.9828L75.6748 91.8289V94.2227",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1788 93.8708C84.8972 94.1525 84.4747 94.3637 83.9819 94.3637H75.6035",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.661 79.5784L72.2958 72.6786C71.8029 71.9041 70.7468 71.6225 69.902 72.1153L68.7755 72.8194C68.4938 73.0306 68.2122 73.3122 68.0714 73.5938L64.3398 80.6345L67.5785 82.3242L70.5356 76.6917",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6612 79.5784L78.6325 78.311L77.7877 84.9292L71.5215 82.7466L73.5633 81.4793",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1426 73.6643C68.565 73.8051 68.9171 74.0163 69.1283 74.4388L73.5639 81.5498",
    stroke: "#135040",
    strokeWidth: 1.3617,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReusableLogo);
export default __webpack_public_path__ + "static/media/reusable-logo.671a023029ef1cd74752d20415a050d5.svg";
export { ForwardRef as ReactComponent };